import { ListService } from '@abp/ng.core';
import { DateAdapter } from '@abp/ng.theme.shared/extensions';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { AssetDetailsDto } from '@proxy/register-service/assets';
@Component({
  selector: 'app-asset-details-event-history',
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [ListService, { provide: NgbDateAdapter, useClass: DateAdapter }],
  templateUrl: './event-history.component.html',
  styleUrls: ['./event-history.component.scss'],
})
export class AssetEventHistoryComponent {
  @Input() asset: AssetDetailsDto;
  @Input() isPageTemporary: boolean = false;
}
